export default __webpack_public_path__ + "static/mitech-client-logo-05-c565b36291c3c827e2df19d50fa74c8a.png";